





































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwModal, SwModalBody } from '@libs-uuif/shared/sw-modal';
import { MswAppTitle } from '@/shared/msw-app-title';
import { InfoState } from '@/core';
import TryNowComponent from './trynow-component.vue';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select/types';
import { TRY_NOW_PRODUCTS_IDS } from '../constant';
import { HostedEmailSecurityRoute } from '@/modules/msw-products/components/msw-product-detail/todoComponents/hostedEmailSecurity';
const cssPrefix = 'msw-free-software-trial';
const cssPrefix2 = 'widget-card';
@Component({
  components: {
    MswAppTitle,
    SwButton,
    SwModal,
    SwModalBody,
    TryNowComponent,
  },
})
export default class MswFreeSoftwareTrial extends SwExtendedVue {
  cssPrefix = cssPrefix;
  cssPrefix2 = cssPrefix2;

  termsandConditionsLink: string = 'https://www.sonicwall.com/legal';
  widgetList: any[] = [];
  openGetFriendlyname:boolean = false;
  productId:string = '';
  serviceId:string = '';
  widgetTitle: string = '';
  noCardsFound:boolean = false;
  productGroupList: SelectOption[] = [];

  openURLInNewTab(url:any) {
    window.open(url, '_blank');
  }

  async created() {
    await this.getFreeSoftwareTrials();
    await this.getProductGroups();
  }

  async getFreeSoftwareTrials() {
    await this.$store.dispatch('MswFreSoftwareTrailModule/getFreeSoftwareTrails')
      .then((resp: any) => {
        if (resp.operationStatus === 'OK') {
          if (resp.content && resp.content.freeTrialWidgetsList) {
            this.widgetList = resp.content.freeTrialWidgetsList;
          }
        } else {
          this.showMessage('failed', resp.msgDesc || this.$t('systemMessages.oprUnSuccss')
          .toString());
        }
      })
      .catch((errResponse:any) => {
        console.error(errResponse);
        this.showMessage(
          'failed',
          this.$t('systemMessages.wrong')
          .toString(),
        );
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  private async getProductGroups() {
    const request = {
      serialNumber: '',
    };
    await this.$store.dispatch('MswProductsStoreModule/getProductGroupList', request)
      .then((resp:any) => {
        if (resp.operationStatus === 'OK') {
          this.productGroupList = resp.arrproductgroup.map((each: any) => {
            return  {
              id: each.groupid,
              label: each.groupname,
              value: each.groupid,
            };
          });
        } else {
          this.showMessage('failed', resp.msgDesc || this.$t('systemMessages.oprUnSuccss')
          .toString());
        }
      })
      .catch((err:any) => {
        console.error(err);
        this.showMessage(
          'failed',
          this.$t('systemMessages.wrong')
          .toString(),
        );
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  onStartTrials(result:any) {
    this.productId = result.productID;
    this.serviceId = result.serviceId;
    this.widgetTitle = result.widgetTitle;
    this.openGetFriendlyname = true;
  }

  onCloseGetFriendlyname() {
    this.openGetFriendlyname = false;
  }

  callSuccess(resp: any) {
    if (this.productId === TRY_NOW_PRODUCTS_IDS.HOSTED_EMAIL_SECURITY) {
      this.onCloseGetFriendlyname();
      this.$router.push({ path: HostedEmailSecurityRoute.path, query: { SN : resp.serialNumber } });
    } else {
      if (this.productId === TRY_NOW_PRODUCTS_IDS.CLOUD_APP_SECURITY_BROKER) {
        this.onCloseGetFriendlyname();
        if (this.$store.getters.isLargeCustomer) {
          this.loadRegisterProductData(resp);
        }
        this.onNavigateToProduct(resp.serialNumber);
      } else {
        this.onCloseGetFriendlyname();
        if (this.$store.getters.isLargeCustomer) {
          this.loadRegisterProductData(resp);
        }
        this.onNavigateToProduct(resp.serialNumber);
      }
    }
  }

  loadRegisterProductData(resp : any) {
    const d = new Date();
    const req = {
      associationType: '',
      casNodeCount: '0',
      ccNodeCount: '0',
      cloudBackupTab: false,
      dtExpired: '',
      dtExpiring: '',
      dtRegistrationDate: `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`,
      dtSupportExpiry: '',
      firmWareTab: false,
      firmwareStatus: '',
      firmwareVersion: '',
      friendlyName: '',
      gmsNodeCount: '0',
      hesNodeCount: '0',
      id: '',
      isDeleteAllowed: 'YES',
      isDownloadAvailable: false,
      isLicenseExpired: false,
      isLicenseExpiring: false,
      isRenameAllowed: 'YES ',
      isSharedProduct: 'NO',
      isTransferAllowed: 'YES',
      isZTEnable: false,
      pID: '',
      pTab: true,
      productDesc: '',
      productGroup: '',
      productName: '',
      productType: '',
      registrationDate: this.getTodayDate(),
      releaseStatus: '',
      saseNodeCount: '0',
      serNo: resp.serialNumber,
      sharedGroupHoverText: '',
      status: 'ENABLED',
      supportExpiry: '',
      userGroups: '',
    };
    const registeredDataCopy = localStorage.getItem('registeredData');
    if (registeredDataCopy !== undefined && registeredDataCopy !== null) {
      const reqArr = JSON.parse(registeredDataCopy);
      reqArr.push(req);
      localStorage.setItem('registeredData', JSON.stringify(reqArr));
    } else {
      const reqArr = [];
      reqArr.push(req);
      localStorage.setItem('registeredData', JSON.stringify(reqArr));
    }
  }

  getTodayDate() {
    const d = new Date();
    const monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${monthArr[d.getMonth()]} ${d.getDate()} ${d.getFullYear()}`;
  }

  onNavigateToProduct(serialNumber: any) {
    this.$router.push({ path:'/m/feature/products', query:{ serialNumber, tab:'productdetails' } });
  }

  showMessage(infoType: string, infoMsg: string): void {
    // success and failed
    const message: InfoState = { infoType, infoMsg };
    this.$store.commit('displayMessage', message);
  }
}
